import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import HomecardImage from '../common/HomecardImage';

import HomecardContent from './components/HomecardContent';
import HomecardDescription from './components/HomecardDescription';
import HomecardDescriptionRedesign from './components/HomecardDescriptionRedesign';
import HomecardWrapper from './components/HomecardWrapper';

export { HOMECARD_IMAGE_RATIOS } from '../common/HomecardImage';

const Homecard = props => {
  const isSimplifyHomecardsDesign =
    useSoyuzExperiment('SimplifyHomecardsDesign').get('behaviour') ===
    'variant';
  return (
    <HomecardWrapper
      {...props}
      renderImage={componentProps => <HomecardImage {...componentProps} />}
      renderContent={componentProps => <HomecardContent {...componentProps} />}
      renderDescription={componentProps =>
        isSimplifyHomecardsDesign ? (
          <HomecardDescriptionRedesign {...componentProps} />
        ) : (
          <HomecardDescription {...componentProps} />
        )
      }
    />
  );
};
export default Homecard;
